import React, { useEffect } from "react";
import { X } from "lucide-react";

const MARA_PHOTO = "/brand/mara-foto.png";

/** Micro-reazione "voce di Mara": slide-in leggero, auto-dismiss,
 * rispetta prefers-reduced-motion. */
export const ReactionCard = ({ reaction, onDismiss }) => {
  useEffect(() => {
    if (!reaction) return undefined;
    const id = setTimeout(onDismiss, 6000);
    return () => clearTimeout(id);
  }, [reaction, onDismiss]);

  if (!reaction) return null;

  return (
    <div
      data-testid="reaction-card"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50
                 bg-surface border border-border rounded-xl shadow-lg p-4 flex items-start gap-3
                 motion-safe:animate-[wl-slide-up_.35s_ease-out]"
      role="status"
    >
      <img
        src={MARA_PHOTO}
        alt="Mara"
        className="w-11 h-11 rounded-full object-cover shrink-0 border border-border"
        style={{ objectPosition: "50% 10%" }}
      />
      <div className="flex-1 min-w-0">
        <div className="text-xs font-semibold text-text-secondary mb-0.5">Mara</div>
        <div className="text-sm text-text-primary leading-snug">{reaction.text}</div>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Chiudi"
        data-testid="reaction-dismiss"
        className="text-text-muted hover:text-text-primary shrink-0"
      >
        <X size={14} />
      </button>
    </div>
  );
};
